import { jsx as _jsx } from "react/jsx-runtime";
import { validateReviewers } from '~/business-logic/draftLogic';
import { allReviewersComplete } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/Recipients/utils/isCompleteReviewer';
import { hasTooFewSigners } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/Recipients/utils/signingRecipients';
import { draftClientId } from '../draftClient.utils';
import { ClientAdditionalRecipientsModalContent } from './ClientAdditionalRecipientsModalContent/ClientAdditionalRecipientsModalContent';
const MODAL_WIDTH = '800px';
export const recipientsCellAvailability = (param)=>{
    let { draft, contact, isDisabled, disabledTooltip, draftCellsTexts } = param;
    if (isDisabled) {
        return {
            isDisabled,
            disabledTooltip
        };
    }
    if (draft.isSample()) {
        return {
            isDisabled: true,
            disabledTooltip: draftCellsTexts.additionalRecipientsSampleDisabled()
        };
    }
    if (draftClientId(draft, contact) == null) {
        return {
            isDisabled: true,
            disabledTooltip: draftCellsTexts.additionalRecipientsRequiresClient()
        };
    }
    return {
        isDisabled: false,
        disabledTooltip: undefined
    };
};
const renderClientAdditionalRecipientsModal = (param)=>{
    let { draft, setDraft, wasSubmitted, anyOneSigns, title, testId } = param;
    return {
        title,
        testId,
        onSubmit: (defaultBehavior)=>void defaultBehavior(),
        content: /*#__PURE__*/ _jsx(ClientAdditionalRecipientsModalContent, {
            draft: draft,
            setDraft: setDraft,
            showReviewerErrors: wasSubmitted,
            anyOneSigns: anyOneSigns
        })
    };
};
const recipientsAreSavable = (param)=>{
    let { reviewers, primaryContact, anyOneSigns, validationTexts, validators } = param;
    return allReviewersComplete(reviewers) && validateReviewers({
        allReviewers: reviewers,
        primaryContact,
        texts: validationTexts,
        validators
    }) && !hasTooFewSigners({
        anyOneSigns,
        primaryContact: primaryContact !== null && primaryContact !== void 0 ? primaryContact : null,
        reviewers
    });
};
export const clientAdditionalRecipientsModalOptions = (param)=>{
    let { title, testId, primaryContact, anyOneSigns, validationTexts, validators } = param;
    return {
        width: MODAL_WIDTH,
        shouldSubmit: (editedDraft)=>Promise.resolve(recipientsAreSavable({
                reviewers: editedDraft.reviewers(),
                primaryContact,
                anyOneSigns,
                validationTexts,
                validators
            })),
        renderContent: (param)=>{
            let { wasSubmitted, draft, setDraft } = param;
            return renderClientAdditionalRecipientsModal({
                draft,
                setDraft,
                wasSubmitted,
                anyOneSigns,
                title,
                testId
            });
        }
    };
};
